import { useState } from 'react';
import { useMonitorStore } from '../lib/monitorStore';
import { DecryptModal } from './DecryptModal';

export function StatsOverlay() {
  const { sessions, selectedSessionId, decryptionKeys } = useMonitorStore();
  const [showDecryptModal, setShowDecryptModal] = useState(false);

  const sessionArray = Array.from(sessions.values());
  const totalSessions = sessionArray.length;
  const connectedHosts = sessionArray.filter((s) => s.hostConnected).length;
  const totalClients = sessionArray.reduce(
    (sum, s) => sum + s.clients.filter((c) => c.authenticated).length,
    0
  );
  const totalPackets = sessionArray.reduce(
    (sum, s) => sum + s.packetStats.hostToClient + s.packetStats.clientToHost,
    0
  );

  // Get active session ID (selected or first)
  const activeSessionId = selectedSessionId || sessionArray[0]?.identifier;
  const hasKey = activeSessionId ? decryptionKeys.has(activeSessionId) : false;

  return (
    <>
      <div className="stats-overlay">
        <h2>Overview</h2>
        <div className="stat-row">
          <span className="stat-label">Sessions</span>
          <span className="stat-value">{totalSessions}</span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Hosts Online</span>
          <span className={`stat-value ${connectedHosts > 0 ? 'connected' : 'disconnected'}`}>
            {connectedHosts}
          </span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Clients</span>
          <span className={`stat-value ${totalClients > 0 ? 'connected' : 'disconnected'}`}>
            {totalClients}
          </span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Total Packets</span>
          <span className="stat-value">{totalPackets.toLocaleString()}</span>
        </div>
        {activeSessionId && (
          <button
            className="decrypt-key-btn"
            onClick={() => setShowDecryptModal(true)}
            title={hasKey ? 'Decryption enabled - click to change key' : 'Add decryption key'}
          >
            {hasKey ? '🔓 Key Set' : '🔒 Add Key'}
          </button>
        )}
      </div>

      {showDecryptModal && activeSessionId && (
        <DecryptModal
          sessionId={activeSessionId}
          onClose={() => setShowDecryptModal(false)}
        />
      )}
    </>
  );
}
